/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavDropdownImageModule_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNavFullWidthDropdownContent_navigationModule$ref: FragmentReference;
export type SiteNavFullWidthDropdownContent_navigationModule = {|
  +imageUrl: ?string,
  +$fragmentRefs: SiteNavDropdownImageModule_navigationModule$ref,
  +$refType: SiteNavFullWidthDropdownContent_navigationModule$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SiteNavFullWidthDropdownContent_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2cf039be77139893eb5e6c946194539e';
module.exports = node;
